import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '../../services/notification';

import api, { makeOptions } from '../../services/api';
import EquipamentoEsportivoListActions from '../ducks/equipamento-esportivo-list';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetch() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/l-equipamento-esportivo`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data, ...pagination } = responseData;
    yield put(EquipamentoEsportivoListActions.success(data, pagination));
  } catch (err) {
    yield put(
      EquipamentoEsportivoListActions.failure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `/l-equipamento-esportivo?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));

    yield put(EquipamentoEsportivoListActions.showSuccess(list));
  } catch (err) {
    yield put(
      EquipamentoEsportivoListActions.showFailure(
        err.response.data.error.message,
      ),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}
